import { Component } from 'react'

import PropTypes from 'prop-types'

import Modal from 'components/Core/Modal'
import Radio from 'components/Core/Radio/Radio'

import {
  OPTION_TO_SCHEDULE,
  OPTION_TO_UNSCHEDULE,
} from './ScheduleForExportModal.constants'
import messages from './ScheduleForExportModal.messages'
import styles from './ScheduleForExportModal.module.css'

class ScheduleForExportModal extends Component {
  state = { selectedOption: null }

  setOption = (e, { value }) => {
    this.setState({ selectedOption: value })
  }

  scheduleForExport = () => {
    const {
      renderActionsToasterMessage,
      selectedOrderIds,
      client: { resetStore },
      scheduleForExport,
      unscheduleForExport,
      handleResetOrder,
    } = this.props
    const { selectedOption } = this.state
    if (selectedOption === OPTION_TO_SCHEDULE) {
      scheduleForExport(selectedOrderIds).then(({ data }) => {
        handleResetOrder(false)
        resetStore()
        const { scheduledOrders } = data.batchScheduleForExport
        renderActionsToasterMessage(
          scheduledOrders.length,
          selectedOrderIds.length - scheduledOrders.length,
        )
      })
    } else if (selectedOption === OPTION_TO_UNSCHEDULE) {
      unscheduleForExport(selectedOrderIds).then(({ data }) => {
        handleResetOrder(false)
        resetStore()
        const { updatedOrderIds } = data.bulkUnscheduleForExport
        const unscheduledOrdersCount = updatedOrderIds.length
        renderActionsToasterMessage(
          unscheduledOrdersCount,
          selectedOrderIds.length - unscheduledOrdersCount,
        )
      })
    }
  }

  render() {
    return (
      <Modal
        title={messages.scheduleExport}
        onClose={this.props.onClose}
        primaryActionLabel={messages.save}
        primaryActionOnClick={this.scheduleForExport}
        primaryDisabled={this.state.selectedOption === null}
        open
      >
        <p className={styles.label}>Select an option</p>
        <div className={styles.radio}>
          <Radio
            checked={this.state.selectedOption === OPTION_TO_SCHEDULE}
            label={messages.scheduleSelected}
            onClick={this.setOption}
            value={OPTION_TO_SCHEDULE}
          />
        </div>
        <div className={styles.radio}>
          <Radio
            checked={this.state.selectedOption === OPTION_TO_UNSCHEDULE}
            label={messages.unscheduleSelected}
            onClick={this.setOption}
            value={OPTION_TO_UNSCHEDULE}
          />
        </div>
      </Modal>
    )
  }
}

ScheduleForExportModal.propTypes = {
  client: PropTypes.object.isRequired,
  selectedOrderIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  scheduleForExport: PropTypes.func.isRequired,
  unscheduleForExport: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  handleResetOrder: PropTypes.func.isRequired,
  renderActionsToasterMessage: PropTypes.func.isRequired,
}

export default ScheduleForExportModal
